import * as React from "react";

const EmailOutlineThin: React.FC = () => {
    return (
        <svg width="81" height="80" viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8.16699 13.3333C7.61471 13.3333 7.16699 13.781 7.16699 14.3333V65.6666C7.16699 66.2189 7.61471 66.6666 8.16699 66.6666H72.8337C73.3859 66.6666 73.8337 66.2189 73.8337 65.6666V14.3333C73.8337 13.781 73.386 13.3333 72.8337 13.3333H8.16699ZM70.5003 16.6666H10.5003V63.3333H70.5003V16.6666ZM70.5003 30.251V26.6666L40.5003 41.8857L10.5003 26.6666V30.251L40.0203 46.404C40.3194 46.5676 40.6813 46.5676 40.9803 46.404L70.5003 30.251Z" fill="currentColor"/>
        </svg>

    );
};

export default React.memo(EmailOutlineThin);
